import React, { useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import { FullScreenLoader, InfoModal } from 'src/app/components';
const WebView: React.FC = () => {

    const location = useLocation();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const { url, downloadURL, headerTitle, showDownloadBtn, downloadErrorMsg } = location.state || {};

    const [loader, setLoader] = useState<boolean>(true);
    const [infoModal, setInfoModal] = useState<boolean>(false);


    const iFrameLoaded = () => {
        setLoader(false);
    }

    const calculateHeight = (value: number) => {
        return window.innerHeight - value;
    }

    const toggleInfoModal = () => setInfoModal(!infoModal);

    const handleDownload = () => {
        if (downloadURL) {
            const link = document.createElement('a');
            link.href = downloadURL;
            link.download = 'sample.pdf';
            link.click();
        } else {
            toggleInfoModal();
            return;
        }
    }

    const infoPopupHTML = () => (
        <div className='info-modal-body'>
            <h2>{downloadErrorMsg || 'Error in download pdf.'}</h2>
        </div>
    )

    return (
        <ProfileLayout title={headerTitle} showDownloadBtn={showDownloadBtn} handleDownload={handleDownload}>
            <div className='position-relative' style={{ height: calculateHeight(100) }}>
                {
                    url ?
                        <>
                            <iframe
                                title="PDFViewerIframe"
                                className={'w-100 mg-t-20'}
                                onLoad={iFrameLoaded}
                                ref={iframeRef}
                                src={url}
                                style={{ height: calculateHeight(100) }}
                            />
                            {loader ? <FullScreenLoader /> : null}
                        </>
                        : <div className='d-flex align-items-center justify-content-center h-100 fs-14 fw-semibold text-black'>Failed to load iframe</div>
                }
            </div>
            <InfoModal
                isInfoModal={infoModal}
                toggleInfoModal={toggleInfoModal}
                informationHtml={infoPopupHTML}
                popupMinHeight={'100px'}
                modalHeader={''}
                customModalHeaderStyle='info-modal-header'
            />
        </ProfileLayout>
    )
}

export default WebView;